module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/doctors/noimage_s200x200-86f376a8c73e6b47f6378894f9399edd.jpg";